import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { navEnable } from '../../actions/nav';
import { getSubscriptionHistory, cancelSubscription, saveTwigInSession, 
		confirmCancellation, closeConfirmation } from '../../actions/subscriptionView';
import Button from 'grommet/components/Button';
import Heading from 'grommet/components/Heading';
import { getPageLoadData } from '../../actions/actions';
import CloseIcon from 'grommet/components/icons/base/Close';
import Layer from 'grommet/components/Layer';

class SubscriptionView extends Component {
    constructor(props) {
        super(props);

		this._renderSubscriptionLog = this._renderSubscriptionLog.bind(this);
		this._renderSubscriptions = this._renderSubscriptions.bind(this);
		this.getCancellationInfo = this.getCancellationInfo.bind(this);
		this.handleConfirmation = this.handleConfirmation.bind(this);
		this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
        this._setDocumentTitle(props);
        this.state = {
			subscriptionDetails : {}
        }
    }

    componentWillMount() {
		this.props.dispatch(navEnable(true));
		this.props.dispatch(getSubscriptionHistory());
    }
    
    componentWillReceiveProps(nextProps) {
        
    }
    
    componentWillUnmount() {
    }

    componentDidmount() {

    }


    _setDocumentTitle(props) {
        document.title = 'Subscription ';
	}

    _renderSubscriptions() {
		let subscriptionTable = [];
		let unsubscribed = [];
		let twigs =[];
		let subscriptions =[];	
		subscriptionTable.push(<div key='subscriptionsHeader' className="subscription-table-header">
			  <div>
				  Stem ID
			  </div>
			  <div>
				  Stem Name
			  </div>
			  <div>
				  Subscription
			  </div>
			  <div>
				  Status 
			  </div>
			  <div>
				  Modify
			  </div>
			</div>);
			if(this.props.subscribedTwigs 
				&& this.props.subscribedTwigs.length > 0) {
				_.forEach(this.props.subscribedTwigs, (data,index) => {
					subscriptions.push(<div key={'subscribed' + index + '_'  + 'twigDetails'} className="subscription-content">
						<div key={'subscribed' + index + '_'  + 'twigId'}>{data.twigId}</div>
						<div key={'subscribed' + index + '_'  + 'name'}>{data.twigName}</div>
						<div key={'subscribed' + index + '_'  + 'stttus'}>{data.details.subscription.plan.name}</div>
						<div key={'subscribed' + index + '_'  + 'status'}>
							<span>Active since {(new Date(data.details.subscription.created*1000).toLocaleDateString())} </span> <br/>
							(renewal period {data.details.subscription.items.data[0].plan.interval_count} {data.details.subscription.items.data[0].plan.interval})
						</div>
							<div key={'subscribed' + index + '_'  + 'changeButtonContainer'} className="button-container">
								<Button key={'subscribed' + index + '_'  + 'changeButton'} label='Change'
									className='lighter-font'
									onClick={()=> this.showPlans(data, true)}
									primary={true}
									secondary={false}
									accent={false} />
								<br/>
								<Button key={'subscribed' + index + '_'  + 'cancelButton'} label='Cancel'
									className='lighter-font'
									onClick={this.cancelSubscription(data)}
									primary={true}
									secondary={false}
									accent={false} />
							</div>
					</div>);
				});
				subscriptionTable.push(...subscriptions);
			}
			if(this.props.unsubscribedTwigs && this.props.unsubscribedTwigs.length > 0){
				_.forEach(this.props.unsubscribedTwigs, (twig,index) => {
					twigs.push(<div key={index + '_'  + 'twigDetails'} className="subscription-content unsubscribed-items">
						<div key={index + '_'  + 'twigId'}>{twig.twigId}</div>
						<div key={index + '_'  + 'name'}>{twig.name}</div>
						<div key={index + '_'  + 'status'}>-</div>
						<div>Unsubscribed</div>
						<div><Button label='Add'
							className='lighter-font'
							onClick={()=> this.showPlans(twig, false)}
							primary={true}
							secondary={false}
							accent={false} />
						</div>
					</div>);
				});
				subscriptionTable.push(...twigs);
			}
		return subscriptionTable;
	}
	getSubscriptionUpdatedTime(data){
		if(data && data.subscription && data.subscription.details 
			&& data.subscription.details.subscription){
			if(data.subscription.details.subscription.canceled_at){
				return new Date(data.subscription.details.subscription.canceled_at *1000).toLocaleString();
			}
			else {
				return new Date(data.subscription.details.subscription.created *1000).toLocaleString();
			}
		}
		else {
			return '';
		}
	}

	_renderSubscriptionLog() {
		let subscriptionHistoryTable = []
		subscriptionHistoryTable.push(<div key='subscriptionsLogHeader' className="subscription-log-table-header">
				<div>
					Date/Time
				</div>
				<div>
					Stem ID
				</div>
				<div>
					Stem Name
				</div>
				<div>
					Changes
				</div>
			</div>
		);
		if(this.props.subscriptionDetails
			&& this.props.subscriptionDetails.length > 0) {
			_.forEach(this.props.subscriptionDetails, (data, index) => {
				let log = (<div key={data.subscription.twigId + '_' + index + 'container'} className="subscription-log-content ">
							<div key={data.subscription.twigId + '_'+ index + 'created'}>{this.getSubscriptionUpdatedTime(data)}</div>
							<div key={data.subscription.twigId + '_'+ index + 'twig'}>{data.subscription.twigId}</div>
							<div key={data.subscription.twigId + '_'+ index + 'name'}>{data.subscription.twigName}</div>
							<div key={data.subscription.twigId + '_'+ index + 'plan'}>{data.action} subscription for<br/>
								{data.subscription.details.subscription.plan.name ? data.subscription.details.subscription.plan.name : data.subscription.details.subscription.plan.nickname}
							</div>
						</div>)
				subscriptionHistoryTable.push(log);			
			});
		}
		return subscriptionHistoryTable;
	}  

	showPlans (data, isSubscribed){
		if(isSubscribed){
			this.props.dispatch(saveTwigInSession({twigId: data.twigId, twigIndex: data.twigIndex, showPlans: true, subscriptionSelected : data}));
			window.location.href ='/location';
		}
		else {
			this.props.dispatch(saveTwigInSession({twigId:data.twigId,  twigIndex: data.twigIndex, showPlans: true}));
			window.location.href ='/location';
		}
	}

	getCancellationInfo () {
		if(this.props.subscriptionToCancel) {
			const data = this.props.subscriptionToCancel;
			return (<Heading strong={false}
			  align='center'
			  margin='small'
			  tag='h3'>
			  Do you want to unsubscribe to the plan ${data.details.subscription.plan.name} with 
			  duration {data.details.subscription.plan.interval_count} 
			  {data.details.subscription.plan.interval} for Stem {data.locationName}/{data.twigId}? 
			  Click Ok to confirm.
			</Heading>);
		  }
	}
	

	cancelSubscription (data){
		return () => {
			this.props.dispatch(confirmCancellation(data));
		}
	}

	handleConfirmation () {
		this.props.dispatch(closeConfirmation(!this.props.showCancellationDialog));
		this.props.dispatch(cancelSubscription(this.props.subscriptionToCancel));	
	}

	closeConfirmationDialog() {
		this.props.dispatch(closeConfirmation(!this.props.showCancellationDialog));
	}

	showConfirmCancellation () {
		return this.props.showCancellationDialog ?
		<Layer flush={true}
		onClose={this.closeConfirmationDialog}
		>
		  <Button icon={<CloseIcon />}
		 onClick={this.closeConfirmationDialog}
		  plain={true} style={{position: 'absolute', float:'right', right: '0'}}/>
			<div style={{textAlign: "center"}} className="heading confirmation-content">
			  {this.getCancellationInfo()}
			  <Button label='OK'
				className='lighter-font button-margin'
				onClick={this.handleConfirmation}
				primary={true}
				secondary={false}
				accent={false} />
			<Button label='Cancel'
				className='lighter-font button-margin'
				onClick={this.closeConfirmationDialog}
				primary={true}
				secondary={false}
				accent={false} />
			</div>
		</Layer> : '';
	}




      

      
    render() {

        const tableStyles = {

        }

        const tableBodyStyles = {
            
        }
        return (
			<div className="subscription-view-container">
				<h3 className="heading">Subscriptions</h3>
				<div className="subscription-details">
					{this._renderSubscriptions()}
				</div>
				<h3 className="heading">History</h3>
				<div className="subscription-log">
					{this._renderSubscriptionLog()}			
				</div>
				{this.showConfirmCancellation()}	
			</div>

        )
    }


}


let select = (state, props) => ({
	subscriptionDetails : state.subscriptionView.subscriptionDetails,
	unsubscribedTwigs : state.subscriptionView.unsubscribedTwigs,
	modifyTwigSubscription: state.subscriptionView.modifyTwigSubscription,
	subscriptionToCancel: state.subscriptionView.subscriptionToCancel,
	showCancellationDialog: state.subscriptionView.showCancellationDialog,
	subscribedTwigs : state.subscriptionView.subscribedTwigs,
	stripeAPIKey : state.session.stripeAPIKey,
	
  });

export default connect(select)(SubscriptionView)


// WEBPACK FOOTER //
// ./src/js/components/subscription/SubscriptionView.js